import { Button } from '@mui/material';
import { MessageList } from 'components/molecules';
import renderIcon from 'icon';
import QUERY_KEYS from 'network/config/queryKeys';
import { getInboxMessages, markAllInboxesAsRead } from 'network/services/inbox';
import { enqueueSnackbar } from 'notistack';
import { useState } from 'react';
import { IoArrowBackCircleSharp } from 'react-icons/io5';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

export const Inbox = () => {
  const navigate = useNavigate();
  const [sortBy, setSortBy] = useState<'date' | 'unread'>('date');
  const queryClient = useQueryClient();

  const { data: messages, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.INBOX],
    queryFn: getInboxMessages
  });

  const { mutate: markAllRead } = useMutation({
    mutationFn: markAllInboxesAsRead,
    onSuccess: () => {
      queryClient.invalidateQueries([QUERY_KEYS.INBOX]);
      enqueueSnackbar('All messages marked as read', { variant: 'success' });
    }
  });

  const sortedMessages = messages?.data?.data?.sort((a: any, b: any) => {
    if (sortBy === 'date') {
      return new Date(b.dateTime).getTime() - new Date(a.dateTime).getTime();
    }
    return a.read === b.read ? 0 : a.read ? 1 : -1;
  });

  if (isLoading) {
    return <div className="p-4 text-center">Loading messages...</div>;
  }

  return (
    <>
      <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
        {renderIcon(IoArrowBackCircleSharp, {
          size: 24,
          className: 'text-black flex-shrink-0 cursor-pointer hover:text-gray-600 transition-colors',
          onClick: () => navigate('/account')
        })}
        <span
          className="font-semibold"
          style={{ color: '#222', cursor: 'pointer' }}
          onClick={() => navigate('/account')}>
          Account
        </span>
        <span>›</span>
        <span className="font-semibold" style={{ color: '#222' }}>
          Inbox
        </span>
      </div>
      <div className="w-full">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4 p-4 bg-white rounded-lg shadow">
          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <Button
              variant="outlined"
              color={sortBy === 'date' ? 'primary' : 'inherit'}
              onClick={() => setSortBy('date')}
              fullWidth={window.innerWidth < 640}
              className="sm:w-auto">
              Sort by Date
            </Button>
            <Button
              variant="outlined"
              color={sortBy === 'unread' ? 'primary' : 'inherit'}
              onClick={() => setSortBy('unread')}
              fullWidth={window.innerWidth < 640}
              className="sm:w-auto">
              Sort by Unread
            </Button>
          </div>
          <Button
            variant="contained"
            sx={{ backgroundColor: 'primary', color: '#fff' }}
            onClick={() => markAllRead()}
            fullWidth={window.innerWidth < 640}
            className="sm:w-auto">
            Mark All as Read
          </Button>
        </div>

        <div className="bg-white rounded-lg shadow">
          {sortedMessages?.map((message: any) => (
            <MessageList
              key={message.id}
              data={message}
              onDelete={() => {
                queryClient.invalidateQueries([QUERY_KEYS.INBOX]);
              }}
            />
          ))}
          {sortedMessages?.length === 0 && <div className="p-4 text-center text-gray-500">No messages found</div>}
        </div>
      </div>
    </>
  );
};
